import React from 'react';
import { CheckCircle } from 'lucide-react';
export function EnrollmentFormPage() {
  return <div className="flex flex-col min-h-screen bg-gradient-to-b from-blue-50 to-white" data-id="element-976">
      <main className="flex-grow pt-20" data-id="element-977">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 py-12" data-id="element-978">
          <div className="max-w-4xl mx-auto" data-id="element-979">
            {/* Success Message */}
            <div className="bg-white rounded-2xl shadow-xl p-8 mb-8 border-2 border-green-100" data-id="element-980">
              <div className="flex items-center gap-4 mb-6" data-id="element-981">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-982">
                  <CheckCircle className="w-8 h-8 text-green-600" data-id="element-983" />
                </div>
                <div data-id="element-984">
                  <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-985">
                    Payment Successful!
                  </h1>
                  <p className="text-gray-600" data-id="element-986">
                    Thank you for enrolling in the Executive Assistant Mastery
                    Course
                  </p>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-6 border border-blue-100" data-id="element-987">
                <h2 className="text-xl font-bold text-gray-900 mb-3" data-id="element-988">
                  Next Step: Complete Your Enrollment
                </h2>
                <p className="text-gray-700 mb-4" data-id="element-989">
                  Please fill out the enrollment form below to complete your
                  registration. This information helps us personalize your
                  learning experience and provide you with the best support
                  throughout the course.
                </p>
                <ul className="space-y-2 text-sm text-gray-600" data-id="element-990">
                  <li className="flex items-start gap-2" data-id="element-991">
                    <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" data-id="element-992" />
                    <span data-id="element-993">
                      You'll receive a confirmation email within 24 hours
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-994">
                    <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" data-id="element-995" />
                    <span data-id="element-996">Course materials will be sent to your email</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-997">
                    <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" data-id="element-998" />
                    <span data-id="element-999">
                      Access to the learning platform will be granted within 48
                      hours
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Enrollment Form */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-gray-100" data-id="element-1000">
              <div className="bg-gradient-to-r from-blue-600 to-green-600 p-6" data-id="element-1001">
                <h2 className="text-2xl font-bold text-white text-center" data-id="element-1002">
                  Enrollment Form
                </h2>
                <p className="text-blue-100 text-center mt-2" data-id="element-1003">
                  Please complete all required fields
                </p>
              </div>

              <div className="p-4 md:p-8" data-id="element-1004">
                <div className="relative w-full" style={{
                minHeight: '600px'
              }} data-id="element-1005">
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdQWsOH6raXsAhQoZk2LgJsRtbPP73JNslzeKYyzCPfSBLm6w/viewform?embedded=true" width="100%" height="1200" frameBorder="0" marginHeight={0} marginWidth={0} className="border-0" title="Enrollment Form" data-id="element-1006">
                    Loading enrollment form...
                  </iframe>
                </div>
              </div>
            </div>

            {/* Support Section */}
            <div className="mt-8 bg-white rounded-2xl shadow-lg p-6 border border-gray-200" data-id="element-1007">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-1008">
                Need Help?
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-1009">
                If you have any questions or need assistance, please contact us:
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1010">
                <a href="mailto:myskillzhq@gmail.com" className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 font-medium" data-id="element-1011">
                  Email Support
                </a>
                <a href="/contact" className="inline-flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors duration-200 font-medium" data-id="element-1012">
                  Contact Page
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
}